<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link id="brand" class="navbar-item" to="/">
        <img src="@/assets/king_white.png" />
      </router-link>

      <a role="button" 
        class="navbar-burger burger"
        aria-label="menu" aria-expanded="false" 
        data-target="navbarMenu"
        @click="isNavBurgerMenuActive = !isNavBurgerMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>  
    <div id="navbarMenu" class="navbar-menu"
      v-bind:class="{ 'is-active' : isNavBurgerMenuActive }"
    >
      <div class="navbar-start">
      </div>
      <div class="navbar-end"><!--
        <div class="navbar-item">
          CV
        </div>-->
        <div class="navbar-item"
          @click="isNavBurgerMenuActive = !isNavBurgerMenuActive"
        >
          <router-link class="navbar-item" to="/#portfolio">portfolio</router-link>
        </div>
        <div class="navbar-item"
          @click="isNavBurgerMenuActive = !isNavBurgerMenuActive"
        >
          <router-link class="navbar-item" to="/impressum">contact</router-link>
        </div>
        
      </div>
    </div>
  </nav>
</template>
<script>

export default {
  name: 'Header',
  components: {
  },
  data: function () {
    return {
      isNavBurgerMenuActive: false
    }
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";

#brand {
  padding-top: 0;
  padding-bottom: 0;

  img {
    // Navbar Height
    max-height: 3.25rem;
  }
}
</style>